<lbca-message-feedback
	[show]="messageFeedObject.show"
	[type]="messageFeedObject.type"
	[autoclose]="messageFeedObject.autoclose"
	(closeFeed)="closeFeed()"
	[emoji]="messageFeedObject.emoji"
>
	<li messagePrimary>{{ messageFeedObject.primary }}</li>
	<li messageSecondary>{{ messageFeedObject.secondary }}</li>
</lbca-message-feedback>

<section class="block w-full mb-[40px] m-8">
	@for (textRegisterPhase of msgRegistrerNewPhase; track textRegisterPhase) {
		<p class="text-2xl highlightEven">
			{{ textRegisterPhase }}
		</p>
	}
</section>

<section class="form-fields-sub-module-modal m-8">
	<div class="ff-row-form overflow-x-hidden mb-[52px]">
		<div class="ff-box-field ff-field-size-3">
			<lbca-entity-fields
				[forceType]="'SELECT_ONE'"
				[removeItens]="filterDateAccordingToRegisteredOptions()"
				[field]="selectNewPhase"
				[label]="getFieldv.selectNewPhase.label"
				[error]="getFieldv.selectNewPhase.error"
				[require]="getFieldv.selectNewPhase.required"
				[value]="getFieldv.selectNewPhase.value"
				[loading]="loading"
				[initialValue]="'1'"
				(changeLabelValue)="changeLabelValueNewClaim($event, getFieldv.selectNewPhase)"
				[cardData]="cardInfo"
				(changeValue)="changeValueNewClaim($event, getFieldv.selectNewPhase)"
			></lbca-entity-fields>
		</div>
	</div>

	@if (table.body && table.body.length > 0) {
		<lbca-table-secondary
			[table]="table"
			[checkItens]="checkMark"
			(checkedItens)="changeCheckedItens($event)"
			[cardData]="cardInfo"
		></lbca-table-secondary>
	}
</section>

<section class="m-8 flex mt-[40px] absolute bottom-[20px]">
	<button type="button" class="btn-secondary btn-type-2 ml-[4px] p-2" (click)="closeModal()">
		{{ claimLabelsDict['btn-cancel'] }}
	</button>
	<button
		type="button"
		class="btn-primary btn-type-2 ml-[25px] load-action p-2"
		[class.btn-motion-bg-primary]="submitButtonRegisterPhase"
		[disabled]="submitButtonRegisterPhase"
		(click)="createStep()"
	>
		@if (!submitButtonRegisterPhase) {
			{{ claimLabelsDict['btn-register-new-phase'] }}
		}
		@if (submitButtonRegisterPhase) {
			<img class="forgot-loading" src="./assets/icons/loading-points.svg" />
		}
	</button>
</section>

<ng-template #marcarTodos let-pedido>
	@if (table.body && table.body.length > 3) {
		<a
			class="text-sm ml-[20px] cursor-pointer"
			[class.text-primary]="checkMark === 'none' || checkMark === 'almost'"
			[class.text-gray-400]="checkMark === 'all'"
			(click)="checkAll('all')"
		>
			{{ claimLabelsDict['opt-mark-all'] }}
		</a>
	}
</ng-template>

<ng-template #desmarcarTodos let-pedido>
	@if (table.body && table.body.length > 3) {
		<a
			class="text-sm ml-[0px] cursor-pointer"
			[class.text-primary]="checkMark === 'all' || checkMark === 'almost'"
			[class.text-gray-400]="checkMark === 'none'"
			(click)="checkAll('none')"
		>
			{{ claimLabelsDict['opt-unmark-all'] }}
		</a>
	}
</ng-template>

<ng-template #templateStepRegistered>
	<div class="text-base text-font flex items-center justify-center show">
		{{ claimLabelsDict['new-phase-registered'] }}
		<div class="emojis-smile icon-box ml-[16px]"></div>
	</div>
</ng-template>
